import React from 'react';
import './App.css';
import PhotoEditor from './components/PhotoEditor/PhotoEditor';
import backgroundImage from './assets/bg.jpg';

function App() {
  return (
    <div 
      className="App" 
      style={{ 
        minHeight: '100vh', // Add this
        width: '100%',      // Add this
        background: `
          linear-gradient(
            135deg,
            rgba(26, 26, 26, 0.85) 0%,
            rgba(42, 42, 42, 0.85) 100%
          ),
          url(${backgroundImage})
        `,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <PhotoEditor/>
    </div>
  );
}

export default App;